/***************************************************************************************************
** useCurrentUrl
***************************************************************************************************/

import { useState, useEffect, useCallback } from "react";
import { compactify, buildUrl } from "@utils";

// const getCurrentUrl = () => {
//   return [window.location.origin, window.location.pathname].join('');
// };

const getCurrentUrlParams = () => {
  const urlSearchParams = new URLSearchParams(window.location.search);
  return compactify(Object.fromEntries(urlSearchParams));
};

export default function useCurrentUrl() {
  const [currentUrl, setCurrentUrl] = useState(window.location.href);
  const [currentUrlParams, setCurrentUrlParams] = useState(() => getCurrentUrlParams());

  const updateUrl = useCallback((url, args = {}) => {
    const title = args.title || document.title;
    const params = args.params || {};
    const mode = args.mode || "replace";

    const newUrl = buildUrl(url, params);

    setCurrentUrl(newUrl);
    setCurrentUrlParams(params);

    if (mode === "push") {
      history.pushState(title, "", newUrl);
      window.dispatchEvent(new Event("pushstate"));
    } else {
      history.replaceState(title, "", newUrl);
      window.dispatchEvent(new Event("replacestate"));
    }
  }, []);

  const updateParams = useCallback((params = {}, args = {}) => {
    const baseUrl = window.location.origin + window.location.pathname;

    updateUrl(baseUrl, {
      params: params,
      title: args.title,
      mode: args.mode,
    });
  }, [updateUrl]);

  useEffect(() => {
    const handleChangeUrl = () => {
      setCurrentUrl(window.location.href);

      const urlParams = getCurrentUrlParams();
      setCurrentUrlParams(urlParams);
    };

    window.addEventListener("popstate", handleChangeUrl);
    window.addEventListener("pushstate", handleChangeUrl);
    window.addEventListener("replacestate", handleChangeUrl);

    return () => {
      window.removeEventListener("popstate", handleChangeUrl);
      window.removeEventListener("pushstate", handleChangeUrl);
      window.removeEventListener("replacestate", handleChangeUrl);
    };
  }, []);

  return {
    url: currentUrl,
    params: currentUrlParams,
    updateUrl: updateUrl,
    updateParams: updateParams,
  };
}
